import type { KeyLabelPair, SavedSearchFilter } from '@sbt-web/networking';
import { SavedSearch, SavedSearchBase } from '@sbt-web/network/types';

interface SavedSearchesIndex {
  [index: string]: SavedSearch;
}

const isSearchSaved = (
  search: SavedSearchBase,
  savedSearches: SavedSearchesIndex
): boolean => indexSearch(search) in savedSearches;

const byUriAscending = (a: SavedSearchFilter, b: SavedSearchFilter): number =>
  a.uri > b.uri ? 1 : -1;

const byKeyAscending = (a: KeyLabelPair, b: KeyLabelPair): number =>
  a.key > b.key ? 1 : -1;

const filtersToKey = (filters: SavedSearchFilter[]): string => {
  return filters
    .sort(byUriAscending)
    .map(
      (f) =>
        `${f.uri}=${f.values
          .sort(byKeyAscending)
          .map((v) => v.key)
          .join(',')}`
    )
    .join('_');
};

const indexSearch = (search: SavedSearchBase): string => {
  const filterKey = filtersToKey(search.filters);

  return `${search.sort}_${search.filters.length}_${filterKey}`;
};

const buildIndex = (
  searches: Array<SavedSearch> | null
): SavedSearchesIndex => {
  if (searches == null) {
    return {};
  }

  const explodedValues = searches.map((s) => {
    return [indexSearch(s), s];
  });

  return Object.fromEntries(explodedValues);
};

export { isSearchSaved, buildIndex };
export type { SavedSearchesIndex };
